import { render } from "./LojaProdutos.vue?vue&type=template&id=24327435&scoped=true"
import script from "./LojaProdutos.vue?vue&type=script&lang=js"
export * from "./LojaProdutos.vue?vue&type=script&lang=js"

import "./LojaProdutos.vue?vue&type=style&index=0&id=24327435&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24327435"]])

export default __exports__